const audio = new Audio("/assets/audio/beep.mp3"); // source http://soundbible.com/1815-A-Tone.html

export function beep(endless = true) {
  audio.loop = endless;
  let promise = audio.play();
  if (promise !== undefined) {
    promise.catch(function() {});
  }
}

export function stopBeep() {
  audio.pause();
  audio.currentTime = 0;
}

export function transactionBeep() {
  beep(false);
}

export function messageBeep() {
  beep(false);
}

export function profileVisitBeep() {
  beep(false);
}
